var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-flex u-flex-spaceBetween",staticStyle:{"margin-bottom":"55px"}},[_c('div',[_c('h2',{staticClass:"PageHeader"},[_vm._v("\n      "+_vm._s(_vm.event.name)+"\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.event.last_update_at)+"\n    ")])]),_vm._v(" "),_c('preview-form-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }